// extracted by mini-css-extract-plugin
export default {"add_composition_view":"AddCompositionView_add_composition_view__EdOtq","dark":"AddCompositionView_dark__PfPVX"};